function showMonthlyRateRent({livingConditions, selfUsedProperty}) {
    return livingConditions === 'RENT' || (livingConditions === 'PROPERTY_OWNERSHIP' && selfUsedProperty === 'no');
}

function showMonthlyRateProperty({livingConditions}) {
    return livingConditions === 'PROPERTY_OWNERSHIP';
}

export {
    showMonthlyRateProperty,
    showMonthlyRateRent
}